import { render, staticRenderFns } from "./wander.vue?vue&type=template&id=4c34f14e"
import script from "./wander.vue?vue&type=script&lang=js"
export * from "./wander.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports